// extracted by mini-css-extract-plugin
export var container = "_52-0";
export var fallback = "_52-5";
export var fallbackIcon = "_52-6";
export var hidden = "_52-2";
export var image = "_52-3";
export var loaded = "_52-4";
export var placeholder = "_52-1";